import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { Permission, PermissionEntitiesNames } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/calc-dims/create/')({
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermissionToResource, isInternalRole },
    } = context;
    const isAllowed =
      (isInternalRole ||
        hasAllowedPermissionToResource({ resource: PermissionEntitiesNames.MEASUREMENT, permission: Permission.UPDATE })) &&
      !!context.featureFlags[FeatureFlags.ShowCalculatedDimensionsPage];
    context.validatePermissions({ isAllowed, preload });
  },
});
